import { GetActiveCreditUsersFn } from "../application-service.domain";

export interface CreditUserListDialogData {
  getActiveCreditUsersFn: GetActiveCreditUsersFn;
}

export interface CreditUserListDialogResult {
  userId: number;
}
